// extracted by mini-css-extract-plugin
export var backdrop = "ResumePreview-module--backdrop--Ybf74";
export var meta = "ResumePreview-module--meta--Upr5D";
export var page = "ResumePreview-module--page--cbeKo";
export var resume = "ResumePreview-module--resume--5Bk7d";